
    const data = {"name":"src/core/icons/receipt-text-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19.5 3.5 18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5M19 19H5V5h14v14M6 15h12v2H6m0-6h12v2H6m0-6h12v2H6V7Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            